export default "__VITE_ASSET__C5Q9r$8X__"